/**
 * @param onClicked {() => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorReturningUserNotYouButtonClick(onClicked) {
    document.querySelectorAll('[data-component="returning-user-not-you-button"]').forEach(notYou => {
        notYou.addEventListener("click", (e) => {
            e.preventDefault();
            onClicked();
        });
    });
}